import React from "react";

export const Select = ({ value, onValueChange, children }) => (
  <div className="relative">
    <select
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
      className="w-full border px-3 py-2 rounded-md focus:ring focus:ring-blue-300"
    >
      {children}
    </select>
  </div>
);

export const SelectTrigger = ({ children }) => children;
export const SelectContent = ({ children }) => children;
export const SelectItem = ({ value, children }) => (
  <option value={value}>{children}</option>
);
export const SelectValue = () => null;
